// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import {
//   Navbar,
//   Nav,
//   Container,
//   Form,
//   Button,
//   Offcanvas,
// } from "react-bootstrap";
// import { RiMenuAddLine } from "react-icons/ri";
// import Logo from "../../assets/img/logo.png";
// import MobNavbar from "../MobileNavbar";

// export default function Header() {
//   const [show, setShow] = useState(false);

//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);
//   return (
//     <>
//       <Navbar bg="light" className="shadow-sm" sticky="top">
//         <Container fluid>
//           <Navbar.Brand>
//             {/* <img
//               src={Logo}
//               width="35%"
//               height="auto"
//               className="d-inline-block align-top ms-lg-3"
//               alt="sivam farms logo"
//             /> */}
//             <div>Chakara arts & crafts</div>
//           </Navbar.Brand>
//           <Nav className="d-none d-lg-block">
//             <Nav.Link className="titleText">ADMIN PANEL</Nav.Link>
//           </Nav>
//           <Form className="d-flex">
//             <Button
//               variant="outline-success"
//               onClick={handleShow}
//               className="d-lg-none">
//               <RiMenuAddLine />
//             </Button>
//           </Form>
//         </Container>
//       </Navbar>
//       <Offcanvas
//         show={show}
//         onHide={handleClose}
//         className="d-lg-none d-xl-block w-40">
//         <Offcanvas.Header closeButton>
//           <Offcanvas.Title>
//             {/* <img
//               src={Logo}
//               width="50%"
//               height="auto"
//               className="d-inline-block align-top ms-lg-3"
//               alt="sivam farms logo"
//             /> */}
//             <div>Chakara arts & Crafts</div>
//           </Offcanvas.Title>
//         </Offcanvas.Header>
//         <Offcanvas.Body>
//           <MobNavbar />
//         </Offcanvas.Body>
//       </Offcanvas>
//     </>
//   );
// }

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container, Button, Offcanvas } from "react-bootstrap";
import { RiMenuAddLine } from "react-icons/ri";
import MobNavbar from "../MobileNavbar";

export default function Header() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Navbar bg="light" className="shadow-sm" sticky="top">
        <Container fluid>
          <Navbar.Brand>
            <div>Chakara Art and Craft</div>
          </Navbar.Brand>
          <Nav className="d-none d-lg-block">
            <Nav.Link className="titleText">ADMIN PANEL</Nav.Link>
          </Nav>
          <Button
            variant="outline-success"
            onClick={handleShow}
            className="d-lg-none"
          >
            <RiMenuAddLine />
          </Button>
        </Container>
      </Navbar>

      {/* Sidebar Offcanvas for Mobile */}
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="start"
        className="d-lg-none w-75"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div>Chakara Art and Craft</div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <MobNavbar handleClose={handleClose} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
